import styled, { css } from 'styled-components'

import Link from '../../Link'

export interface ItemDisplayModeProps {
  $displayMode?: 'normal' | 'compact'
}

export const ItemTitle = styled.div`
  color: ${({ theme }) => theme.colors.chathamsBlue.shade600};
  display: block;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: 1px;
  text-align: left;
  margin-top: 8px;
  text-decoration: none;
  width: 100%;
`

const commonItemContainerStyles = css`
  align-items: center;
  display: flex;
  overflow: hidden;
  max-height: 200px;
  max-width: 100%;
  text-decoration: none;
  white-space: normal;
  text-transform: unset;
  &:hover,
  &:focus {
    outline: none !important;
    ${ItemTitle} {
      color: ${({ theme }) => theme.colors.neutralGray.neutral900};
    }
  }
`

export const ItemContainerLink = styled(Link)`
  ${commonItemContainerStyles};
  max-height: unset;
`

export const ItemContainer = styled.div`
  ${commonItemContainerStyles}
`

export const ItemImageContainer = styled.div<ItemDisplayModeProps>`
  flex: 0 0 calc(100% / 3);
  max-width: ${({ $displayMode }) => ($displayMode === 'compact' ? '115px' : 'unset')};
  background-color: ${({ theme }) => theme.colors.coolGray.cool100};
  position: relative;
  &:after {
    display: block;
    content: '';
    padding-top: 100%;
  }
`

export const ItemImage = styled.img`
  position: absolute;
  top: 0;
  display: block;
  margin: 50%;
  height: 144px;
  width: 144px;
  align-content: center;
  text-align: center;
  object-fit: contain;
  transform: translateX(-50%) translateY(-50%);
`

export const SearchResult = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 190px;
  width: 100%;
`
